import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'

// All-time, not scoped to the dashboard's date range picker — matches the
// "All-time" label shown alongside it.
export function useTotalMembers() {
  return useQuery({
    queryKey: ['total-members'],
    queryFn: async () => {
      const { count, error } = await supabase
        .from('member_profiles')
        .select('id', { count: 'exact', head: true })
        .eq('is_anonymised', false)
      if (error) throw error
      return count ?? 0
    },
  })
}
